import { useMediaQuery } from "@mui/material";

const useIsLargeScreen = () => {
  const IsDesktopMedia = useMediaQuery("(min-width:2500px)");
  return IsDesktopMedia;
};

export default useIsLargeScreen;
